<script>
    import Icon from "@iconify/svelte";
    import { onMount, tick } from "svelte";

    let {
        title = "Job Titel",
        company = "Firma",
        category = "Industrie",
        location = "Einsatzort",
        is_ship = false,
        employment_mode = "Vollzeit",
        logo = "",
        url = "#",
        index = 0, // Position der Kachel
        layout = "down", // 'up' oder 'down'
        trancate_count = 30,
        title_count = 75,
    } = $props();
    let isDesktop = $state(false);
    let cardEl;

    onMount(() => {
        isDesktop = window.innerWidth >= 1024;
        console.log("isDesktop:", isDesktop, "| innerWidth:", window.innerWidth);
        trackClick("job_card_load");
        const onResize = () => {
            isDesktop = window.innerWidth >= 1024;
        };

        window.addEventListener("resize", onResize);

        // Fire the load tracking only after the element is fully rendered/painted.
        let rafId1 = 0;
        let rafId2 = 0;
        (async () => {
            // Wait for Svelte to flush pending DOM updates
            await tick();
            // Wait for the browser to layout & paint the element
            rafId1 = requestAnimationFrame(() => {
                rafId2 = requestAnimationFrame(() => {
                    if (cardEl && cardEl.isConnected) {
                        trackClick("job_card_load");
                    }
                });
            });
        })();

        return () => {
            window.removeEventListener("resize", onResize);
            if (rafId1) cancelAnimationFrame(rafId1);
            if (rafId2) cancelAnimationFrame(rafId2);
        };
    });

    function pushDataLayer() {
        trackClick("job_card_click");
    }

    function trackClick(name) {
        if (typeof window !== "undefined" && typeof window.push_datalayer === "function") {
            window.push_datalayer({
                event: name,
                job_title: title,
                job_card_position: index + 1,
                job_layout: layout,
                job_company: company,
            });
        } else {
            console.warn("push_datalayer not defined");
        }
    }

    function truncate(text, max = 50) {
        return text.length > max ? text.slice(0, max) + "..." : text;
    }

    function cleanTitle(title) {
        if (!title) return "";

        const forms = ["m/w/d", "w/m/d", "w/d/m", "d/m/w", "d/w/m", "m/d/w"];

        // Muster wie bei cleanCompanyName → aber mit Genderformen
        const regex = new RegExp(`\\(\\s*(${forms.join("|")})\\s*\\).*?$`, "i");
        return title.replace(regex, "($1)").trim();
    }

    function filterEmploymentMode(mode) {
        if (!mode) return "";
        return mode.replace(/Festanstellung\s*/i, "").trim();
    }

    function cleanCompanyName(name) {
        if (!name) return "";

        const forms = ["GmbH", "UG", "AG", "KG", "OHG", "SE", "GbR"];

        // Regex: Rechtsform finden + alles danach entfernen
        const regex = new RegExp(`\\b(${forms.join("|")})\\b.*$`, "i");
        return name.replace(regex, "$1").trim();
    }

    function cleanLocation(location) {
        if (!location) return "";
        return location.trim().split(/\s+/)[0];
    }
</script>

<a bind:this={cardEl} href={url} on:click={pushDataLayer} class="text-decoration-none" target="_blank" style=" font-weight: normal; text-decoration: none !important;">
    <div class="shadow-sm border border-dark rounded-3 mb-3">
        <div class="d-flex">
            <!-- Logo -->
            <div class="m-3">
                <div class=" border d-flex rounded-2 p-1 justify-content-center" style=" width: 90px; height: 70px;">
                    <img style="max-width: 100%; max-height: 100%; object-fit: contain;" src={logo} alt="Logo" />
                </div>
            </div>
            <!-- Textinhalt -->
            <div class=" mt-3 me-3 d-flex">
                <div>
                    <div class=" titlesize fw-semibold title-two-lines" title={cleanTitle(title)}>
                        {truncate(cleanTitle(title), layout === "down" ? (isDesktop ? 75 : 50) : 75)}
                    </div>
                    <div class="companysize fw-normal mb-1 mt-2 text-black overflow-hidden">{truncate(cleanCompanyName(company), trancate_count)}</div>
                    <div class="categorysize fw-light text-black-50 overflow-hidden">{truncate(category, trancate_count)}</div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row-reverse mt-2 mb-3 me-3">
            <div class="  d-flex gap-2">
                <span class="hp_btn-primary fw-semibold px-2 py-1 rounded-1">
                    {is_ship ? "Auf dem Schiff" : cleanLocation(location)}
                </span>
                <span class="hp_btn-primary fw-semibold px-2 py-1 rounded-1">
                    {filterEmploymentMode(employment_mode)}
                </span>
            </div>
        </div>
    </div>
</a>

<style>
    .title-two-lines {
        display: -webkit-box;
        -webkit-line-clamp: 2; /* Maximal 2 Zeilen */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.2rem; /* Zeilenhöhe */
        height: 2.4rem; /* 2 × line-height = immer 2 Zeilen */
    }

    /* Standardgröße für Desktop */
    .titlesize {
        font-size: 16px !important;
    }

    .companysize {
        font-size: 15px !important;
    }

    .categorysize {
        font-size: 15px !important;
    }

    .hp_btn-primary {
        font-size: 12px !important;
    }

    /* Tablet (max-width: 992px) */
    @media (max-width: 992px) {
        .titlesize {
            font-size: 16px !important;
        }

        .companysize {
            font-size: 15px !important;
        }

        .categorysize {
            font-size: 15px !important;
        }

        .hp_btn-primary {
            font-size: 12px !important;
        }
    }

    /* Handy (max-width: 768px) */
    @media (max-width: 768px) {
        .titlesize {
            font-size: 14px !important;
        }

        .companysize {
            font-size: 12px !important;
        }

        .categorysize {
            font-size: 12px !important;
        }

        .hp_btn-primary {
            font-size: 10px !important;
        }
    }
</style>
